import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import {
  useInvalidateTargetPrevSalesOrders,
  useTargetPrevSalesOrders,
} from '@/hooks/api/1265_target_prev_sales_orders';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCreatePrevSalesOrder } from '@/hooks/api/2640_create_prev_sales_orders';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { FormGroup } from '@/components/element/Form/FormGroup';
import { SelectSingle } from '@/components/element/Form/SelectSingle';
import { useEffect, useState } from 'react';
import { SelectOptionType } from '@/components/element/Form/SelectOptionType';
import { SalesOrderOutlineLogic } from '@/hooks/api/models/logics';
import { SingleValue } from 'react-select';
import { toastApiError } from '@/lib/toast';
import { useInvalidatePrevSalesOrders } from '@/hooks/api/1262_prev_sales_orders';
import { useInvalidateNextSalesOrders } from '@/hooks/api/1263_next_sales_orders';
import { useLoading } from '@/providers/LoadingProvider';

type FormInputs = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  prev_sales_order_id: number;
};
export const PrevSalesOrderCreateForm = () => {
  const { setShowLoading } = useLoading();
  const { _so_ } = useCurrentSalesOrder();
  const { _w_, _t_ } = useCurrentTeamMember();
  const orderParams = { identifier: _w_!.identifier, team_id: _t_!.id, id: _so_!.id };

  const { data: targetPrevOrders } = useTargetPrevSalesOrders(orderParams);
  const { invalidate: invalidatePrevOrders } = useInvalidatePrevSalesOrders(orderParams);
  const { invalidate: invalidateNextOrders } = useInvalidateNextSalesOrders(orderParams);
  const { invalidate: invalidateTargetPrevOrders } = useInvalidateTargetPrevSalesOrders(orderParams);

  const { mutate, data, isPending, error } = useCreatePrevSalesOrder();
  const [options, setOptions] = useState<SelectOptionType[]>([]);

  const {
    control,
    getValues,
    setValue,
    trigger,
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>({
    mode: 'onBlur',
    criteriaMode: 'all',
    defaultValues: {
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      sales_order_id: _so_!.id,
    },
  });

  useEffect(() => {
    if (targetPrevOrders && targetPrevOrders.length > 0) {
      setOptions(
        targetPrevOrders.map((d): SelectOptionType => ({ value: d.id, label: SalesOrderOutlineLogic.toLabel(d) }))
      );
    } else {
      setOptions([]);
    }
  }, [targetPrevOrders]);

  const onSalesOrderChange = (sv: SingleValue<SelectOptionType>) => {
    if (sv) {
      setValue('prev_sales_order_id', sv.value);
      trigger('prev_sales_order_id');
    } else {
      reset(undefined, { keepDefaultValues: true });
    }
  };

  useEffect(() => setShowLoading(isPending), [isPending]);
  useEffect(() => toastApiError(error), [error]);

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    setShowLoading(true);
    mutate(data);
  };

  useEffect(() => {
    if (data) {
      invalidateTargetPrevOrders();
      invalidatePrevOrders();
      invalidateNextOrders();
      reset(undefined, { keepDefaultValues: true });
    }
  }, [data]);

  return (
    <>
      <div className="form-group">
        <label>プロジェクト名</label>
        <p className="form-text text-muted text-sm ms-1">{_so_!.name}</p>
      </div>
      <hr className="horizontal dark my-3" />
      <div className="col-12 col-md-9">
        <FormGroup label="以前のプロジェクト（売上）を選択" required={true} classes={''}>
          <Controller
            control={control}
            name="prev_sales_order_id"
            rules={{ required: true }}
            render={({ field: { ref, ...field } }) => (
              <SelectSingle
                options={options}
                selectedId={getValues('prev_sales_order_id')}
                onChange={onSalesOrderChange}
                error={errors.prev_sales_order_id != null}
              />
            )}
          />
        </FormGroup>
      </div>
      <div className="col-12 col-md-3">
        <div className="form-group">
          <label>&nbsp;</label>
          <button className="btn w-100 btn-icon bg-gradient-dark" onClick={() => handleSubmit(onSubmit)()}>
            <i className="fa fa-plus"></i>追加
          </button>
        </div>
      </div>
    </>
  );
};
